import {statusOptions as states, typeOptions as types} from './../constants/consignment-constants';

export class Consignment {
    constructor(
        uuid,
        createdBy,
        createdAt,
        code,
        type,
        issueDate,
        presentationDate,
        chargeDate,
        description,
        status,
        headquarters,
        periodicities,
        receipts,
        sepaXml,
        seatsDiary,
        seatsSubAccounts,
        bankAmount,
        collectorAmount,
        receiptAmount,
        totalAmount,
        numberReceipts
    ) {
        this.uuid = uuid;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.code = code;
        this.type = type;
        this.issueDate = issueDate;
        this.presentationDate = presentationDate;
        this.chargeDate = chargeDate;
        this.description = description;
        this.status = status;
        this.headquarters = headquarters;
        this.periodicities = periodicities;
        this.receipts = receipts;
        this.sepaXml = sepaXml;
        this.seatsDiary = seatsDiary;
        this.seatsSubAccounts = seatsSubAccounts;
        this.bankAmount = bankAmount;
        this.collectorAmount = collectorAmount;
        this.receiptAmount = receiptAmount;
        this.totalAmount = totalAmount;
        this.numberReceipts = numberReceipts;
    }

    getStatusName() {
        let status = states.find(status => (status.key === this.status));
        return !!status ? status.value : null;
    }

    getTypeName() {
        let type = types.find(type => (type.key === this.type));
        return !!type ? type.value : null;
    }

    isCreatedStatus() {
        return ('CREATED' === this.status);
    }

    isIssuedStatus() {
        return ('ISSUED' === this.status);
    }

    isPostedStatus() {
        return ('POSTED' === this.status);
    }

    isNormalType() {
        return ('NORMAL' === this.type);
    }

    isReturnType() {
        return ('RETURN' === this.type);
    }
}